/* eslint-disable import/no-extraneous-dependencies */
import Swan from "@swan-admin/swan-ai-measurements";

enum URLType {
  DEV = "dev",
  STAGING = "staging",
  PROD = "prod",
}

interface SwanServiceParams {
  urlType?: URLType | string;
}

// const DEFAULT_ACCESS_API = "8e35dfd4-010c-40ca-ad79-fc72dc307efb";
const DEFAULT_URL_TYPE = URLType.STAGING;

const swanInstances = new Map<string, Swan>();

const resolveUrlType = (value?: URLType | string): URLType => {
  const normalized = value?.toString().toLowerCase();
  if (normalized === URLType.PROD) return URLType.PROD;
  if (normalized === URLType.STAGING) return URLType.STAGING;
  return URLType.STAGING;
};

const INTERNAL_SWAN_PARAMS: SwanServiceParams = {
  urlType: URLType.STAGING,
};

export const getSwanService = (token?: string): Swan => {
  // const accessKey =  DEFAULT_ACCESS_API;
  const urlType = resolveUrlType(INTERNAL_SWAN_PARAMS?.urlType) || DEFAULT_URL_TYPE;
  const cacheKey = `${token}:${urlType}`;

  if (!swanInstances.has(cacheKey)) {
    swanInstances.set(cacheKey, new Swan(undefined, urlType,token));
  }

  return swanInstances.get(cacheKey)!;
};
